import { writable } from 'svelte/store'

export const width = writable(0);
export const height = writable(0);
export const vHeight = writable(0);
export const landscape = writable(false);

export default {
    width,
    height,
    vHeight,
    landscape
}